import type { SerializeFrom } from "~/lib/types";
import { useLocationState } from "~/location-state/location-state";

import type { loader } from "../shop.$categoryId";

type LoaderData = Awaited<SerializeFrom<typeof loader>["data"]>;

export type ProductListHystoryState = {
  predata?: LoaderData;
  postdata?: LoaderData;
};

export const isProductListHystoryState = (
  state: any,
): state is ProductListHystoryState => {
  return (
    state?.predata?.hits?.length !== undefined ||
    state?.postdata?.length !== undefined
  );
};

export const useProductListHistoryState = () => {
  const [state, set] = useLocationState<ProductListHystoryState>();
  if (isProductListHystoryState(state)) return [state, set] as const;
  return [undefined, set] as const;
};
